import { render, staticRenderFns } from "./FormPostOffice.vue?vue&type=template&id=28a63bb1&scoped=true&"
import script from "./FormPostOffice.vue?vue&type=script&lang=js&"
export * from "./FormPostOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a63bb1",
  null
  
)

export default component.exports